import { IncidentModule } from '@/@types/incidentService';
import { Party } from '@/@types/incidentPartyService';

export default (incidentKey: IncidentModule['key'], partyKey: Party['key']): void => {
  localStorage.setItem('LKFLS-self-check', `${incidentKey}/${partyKey}`);
};
